<script setup lang="ts">
import { SwiperSlide } from 'swiper/vue';
import type { IExpertOpinionsItemDataClientDTO } from '~/shared/api/client/expert-opinions/expert-opinions.dto';

import { DEFAULT_PUBLISHER_STYLE_PROPS_EXPERTS } from '~/shared/lib/publishers.const';
import type { TPublisherStyleProps } from '~/shared/lib/publishers.types';

const { $viewport } = useNuxtApp();
const visibleSlides = computed(() =>
  $viewport.isGreaterOrEquals('desktop') ? 2 : 1,
);

const props = withDefaults(
  defineProps<
    {
      items: IExpertOpinionsItemDataClientDTO[];
    } & TPublisherStyleProps
  >(),
  DEFAULT_PUBLISHER_STYLE_PROPS_EXPERTS,
);

const itemsCount = computed(() => props.items.length);
const isControlVisible = computed(() => itemsCount.value > visibleSlides.value);

const DATA = computed(() => ({
  title: 'Мнения экспертов',
  arrowColor:
    props.textColor || DEFAULT_PUBLISHER_STYLE_PROPS_EXPERTS.textColor,
  borderColor:
    props.borderColor || DEFAULT_PUBLISHER_STYLE_PROPS_EXPERTS.borderColor,
  backgroundColor:
    props.backgroundColor ||
    DEFAULT_PUBLISHER_STYLE_PROPS_EXPERTS.backgroundColor,
  textColor: props.textColor || DEFAULT_PUBLISHER_STYLE_PROPS_EXPERTS.textColor,
  breakpoints: false,
  isControlVisible: isControlVisible.value,
}));
</script>

<template>
  <Slider v-if="items.length > 0" v-bind="DATA">
    <SwiperSlide
      v-for="(item, key) in items"
      :key="`sliderRetail_${key}`"
      :style="{
        borderColor: DATA.borderColor,
        width: `${100 / visibleSlides}%`,
      }"
      :class="$style.slide"
    >
      <SliderItemExperts
        v-bind="item"
        :id="item.expert?.expert_url_id ?? item.expert?.id"
        :text-color="DATA.textColor"
        :title="item.title"
        :image="item.expert?.person?.photo?.file_url ?? ''"
        :author="item.expert?.person?.fio ?? ''"
        :company="item.expert?.person?.company?.name ?? ''"
        :category="item.expert?.category"
      />
    </SwiperSlide>
  </Slider>
</template>

<style module lang="scss">
.slide {
  width: 100%;
  height: auto;
  border-right: 1px solid;
}

@media (max-width: 767px) {
  .slide {
    border-right: none;
  }
}
</style>
